import * as React from 'react';
import MapComponent from '../components/mapComponent';
import Shell from '../layout/shell';
import { AppContext } from '../context/appProvider';
import './index.scss';
import FilterList from '../components/filterList';
import CompanyPanel from '../components/companyPanel';
import { ILocation } from '../typings/data';
import TechSparkPanel from '../components/techsparkPanel';
import Footer from '../components/footer';

const Index: React.FunctionComponent<{}> = () => {
  const { filteredLocations } = React.useContext(AppContext);

  const [selectedLocation, setSelectedLocation] = React.useState<ILocation>();
  const [filtersPanelOpen, setFiltersPanelOpen] = React.useState(true);

  return (
    <Shell>
      <MapComponent locations={filteredLocations} location={selectedLocation} onMarkerClick={setSelectedLocation} />

      <div className={!filtersPanelOpen ? 'filters closed' : 'filters open'}>
        <div className="panel-tab-container">
          <div className="panel-tab">
            <p>
              <img alt="filter plus sign" src={`/icons/filter3.svg`} />
              FILTERS
            </p>
          </div>
        </div>
        {filtersPanelOpen && <FilterList />}
      </div>
      {selectedLocation ? (
        <CompanyPanel onCompanyClick={setSelectedLocation} location={selectedLocation} />
      ) : (
        <TechSparkPanel onCompanyClick={setSelectedLocation} />
      )}
      <Footer />
    </Shell>
  );
};

export default Index;
